import {Component} from '@angular/core';
import { LoginInfoComponent } from '../../../shared/components/login-info/login-info.component';
import { LanguageSelectorComponent } from '../../../shared/components/language-selector/language-selector.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-thank-you',
    templateUrl: './thank-you.component.html',
    styleUrls: ['./thank-you.component.scss'],
    imports: [
        LoginInfoComponent,
        LanguageSelectorComponent,
        TranslatePipe,
    ],
})
export class ThankYouComponent {}
